import * as Yup from "yup";
import Breadcrumbs from '../../components/BreadCrumbs';
import { Form, Formik } from 'formik';
import InputField from '../../components/inputFields/InputField';
import Button from '../../components/buttons/Button';
import { useNavigate } from 'react-router-dom';
import { getUserRole } from '../../utils/localStoarege';
import FormikDropdown from '../../components/inputFields/FormikDropDown';
import { toast } from 'react-toastify';
import { addNewMedicine } from '../../services/clinic/medicine';

function AddMedicine() {
    const navigate = useNavigate();

    const handleFormSubmit = async (values, { setSubmitting }) => {
        try {
            const formData = new FormData();
            formData.append("drug_name", values.drug_name);
            formData.append("amount", values.amount);
            formData.append("type", values.type);
            formData.append("batch_no", values.batch_no);
            if (values.type === 'tablet') {
                formData.append("tablets_per_packet", values.qty_per_pack);
            } else {
                formData.append("ml_per_unit", values.qty_per_pack);
            }
            const response = await addNewMedicine(formData);

            if (response?.status === 201) {
                toast.success("Medicine added successfully!");
                navigate(getUserRole() === 'medical' ? "/medical/home" : "/medicine"); // Redirect to invoice page
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    const handleDiscardChanges = (resetForm) => {
        resetForm(); // Reset the form
        navigate(getUserRole() === 'medical' ? "/medical/home" : "/medicine"); // Redirect to invoice page
    };

    return (
        <>
            <Breadcrumbs items={[
                { name: 'Home', link: '/invoice' },
                { name: 'Medicines', link: '/medicine' },
                { name: 'Add Medicine' },
            ]} />
            <div className="mt-8">
                <Formik
                    initialValues={{
                        drug_name: "",
                        amount: "",
                        type: "tablet",
                        // batch_no: "",
                        qty_per_pack: "1",
                    }}
                    validationSchema={Yup.object({
                        drug_name: Yup.string().required("Please enter a name"),
                        amount: Yup.number().required("Please enter an amount"),
                        type: Yup.string().required("Please select type"),
                    })}
                    onSubmit={handleFormSubmit}
                >
                    {({ isSubmitting, setFieldValue, resetForm, values }) => (
                        <Form>
                            <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100">
                                <div className="grid gap-6 md:grid-cols-3">
                                    <InputField
                                        label="Name"
                                        name="drug_name"
                                        type="text"
                                        placeholder="Medicine Name"
                                        required
                                    />
                                    {/* <InputField
                                        label="Batch No"
                                        name="batch_no"
                                        type="text"
                                        placeholder="BATCH NO."
                                    /> */}
                                    <FormikDropdown
                                        label="Type"
                                        name="type"
                                        placeholder="Select Type"
                                        required={true}
                                        options={[
                                            { label: "Tablet", value: "tablet" },
                                            { label: "Ointment", value: "ointment" },
                                        ]}
                                    />
                                    <InputField
                                        label={values.type === "tablet" ? "Tablets per strip" : "Ointment per unit"}
                                        name="qty_per_pack"
                                        type="text"
                                        placeholder="13"
                                    />
                                    <InputField
                                        label="Amount per pack"
                                        name="amount"
                                        type="text"
                                        placeholder="1200"
                                        required={true}
                                    />
                                </div>
                                <div className="py-5 flex justify-end gap-6">
                                    <div>
                                        <Button
                                            type="button"
                                            className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                            onClick={() => handleDiscardChanges(resetForm)}
                                            disabled={isSubmitting}
                                        >
                                            Discard Changes
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="submit"
                                            className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Saving..." : "Save"}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );
}

export default AddMedicine;
